import {IpType} from "./iptype.model";
import {Actions} from "./actions.model";
import {Destinations} from "./destinations.model";

export class InputForm {
  ipType = IpType.ipv4;
  sourceDevice = "";
  action = Actions.a_ping;
  destination = Destinations.your_ip;
  target = "";
  destinationDevice = "";
}
